import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import GetDataProvider from "./pages/Handles/context";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <GetDataProvider>
          <App />
      </GetDataProvider>
  </React.StrictMode>
);


